/**
 * @generated SignedSource<<9222c800528c3ea7c36463eddb01c7ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutGuestBuyerQueryRenderer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptionsQueryRenderer_viewer" | "CheckoutMobilePageHeader_viewer" | "CheckoutPageHeader_viewer" | "useBuyerFetchHandler_viewer">;
  readonly " $fragmentType": "CheckoutGuestBuyerQueryRenderer_viewer";
};
export type CheckoutGuestBuyerQueryRenderer_viewer$key = {
  readonly " $data"?: CheckoutGuestBuyerQueryRenderer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutGuestBuyerQueryRenderer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutGuestBuyerQueryRenderer_viewer",
  "selections": [
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CheckoutPageHeader_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptionsQueryRenderer_viewer"
    },
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CheckoutMobilePageHeader_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBuyerFetchHandler_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1f924ae7d8f8744a708cf83a195addcb";

export default node;
